import { render, staticRenderFns } from "./PenunjukanKerja.vue?vue&type=template&id=4e68a773&scoped=true&lang=html&"
import script from "./PenunjukanKerja.vue?vue&type=script&lang=js&"
export * from "./PenunjukanKerja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e68a773",
  null
  
)

export default component.exports